import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=b6cefefe&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=b6cefefe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cefefe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6cefefe')) {
      api.createRecord('b6cefefe', component.options)
    } else {
      api.reload('b6cefefe', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=b6cefefe&scoped=true&", function () {
      api.rerender('b6cefefe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-255CJPeUaHTlU/JS/comp/CookieBox.vue"
export default component.exports